/*
 * @Author: wang.zhiqin wang.zhiqin@trs.com.cn
 * @Date: 2023-07-10 18:08:40
 * @LastEditors: sunyan 1055697528@qq.com
 * @LastEditTime: 2024-04-16 10:28:59
 * @FilePath: \jsczt_vue\src\store\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    sjName: '',
    sjFileType: '',
    sjParentid:'',
    sjChnlid:'',
    sjclassinfoid:'',
    year: null,
    place: {},
    startYear:'',
    endYear:'',
    code: null,
    parentid: null,
    params: {},
    detailParams:{}
  },
  mutations: {
    // set
    setSjName(state, sjName) {
      state.sjName = sjName
    },
    setSjFileType(state, sjFileType) {
      state.sjFileType = sjFileType
    },
    setSjParentid(state, sjParentid) {
      state.sjParentid = sjParentid
    },
    setSjChnlid(state, sjChnlid) {
      state.sjChnlid = sjChnlid
    },
    setClassinfoid(state,sjclassinfoid){
      state.sjclassinfoid = sjclassinfoid
    },
    setstartYear(state, startYear) {
      state.startYear = startYear
    },
    setendYear(state, endYear) {
      state.endYear = endYear
    },
    setdetailParams(state, detailParams) {
      state.detailParams = detailParams
    },
    SET_YEAR(state, year) {
      state.year = year
    },
    SET_PLACE(state, place) {
      state.place = place
    },
    
    SET_CODE(state, code) {
      state.code = code
    },
    SET_PARENTID(state, parentid) {
      state.parentid = parentid
    },
    SET_PARAMS(state, params) {
      state.parentid = params
    }
  },
  getters:{
    //get方法
    // getSjName: state => state.sjName,
    // getSjFileType: state => state.sjFileType,
    // getSjParentid: state => state.sjParentid
  },
  actions: {
    setUser({ commit }, year) {
      commit('SET_YEAR', year)
    },
    setPlace({ commit }, place) {
      commit('SET_PLACE', place)
    },
    setCode({ commit }, code) {
      commit('SET_CODE', code)
    },
    setParentid({ commit }, parentid) {
      commit('SET_PARENTID', parentid)
    },
    setParams({ commit }, params) {
      commit('SET_PARAMS', params)
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js